import axios from "axios";
import { baseUrl, SELF_SERVICE_API_URL } from "../../utils/env";
import { Auth } from "aws-amplify";

export const SS_REDIRECT_URL = `${SELF_SERVICE_API_URL}/api/v1/redirect/login`


export const buildCurrentLocation = () => {
    return window.location.protocol + '//' + window.location.host + window.location.pathname
}

export const splitName = (fullName: string) => {
    let firstName: string = '';
    let lastName: string = '';
    if (fullName) {
        const name = fullName.split(' ')
        lastName = name.pop() || ''
        firstName = name.join(' ')
    }
    return [firstName, lastName]
}

export const addContact = async (email : string, firstName: string, lastName: string) => {
    try {
        await axios.post(`${baseUrl}/api/contact`, {
            email,
            firstName,
            lastName
        })
    } catch (e) {
        console.log(e);
    }
}

export const signUp = async (username: string, password: string, given_name: string, family_name: string, zoneinfo: string, vertical: string = "", captcha: string | null) => {
    const payload = {
        username,
        password,
        attributes: {
            given_name,
            family_name,
            "custom:platform_data": JSON.stringify({
                self_service: true,
                company_name: null,
                creation_info: JSON.stringify({ state: "running", profile: "Self-Service|ASR" }), // TODO: Replace profile according to vertical?
            }),
            "custom:ss_version": "2",
        },
        autoSignIn: {
            enabled: true,
        },
        validationData: { recaptchaToken: captcha, refererDomain: window.location.hostname },
    }
    if (vertical) {
        payload.clientMetadata = { template_name: vertical }
    }
    const { user } = await Auth.signUp(payload);
    return user
}